/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DailySnapshotData } from '../models/DailySnapshotData';

export class ListDailySnapshotsResponse {
  'dailySnapshots'?: Array<DailySnapshotData>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dailySnapshots",
      "baseName": "dailySnapshots",
      "type": "Array<DailySnapshotData>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListDailySnapshotsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

